<template>
  <v-sheet rounded class="px-6 py-6">
    <ui-box-label v-if="label || $slots.label" class="mb-4">
      <slot name="label">
        {{ label }}
      </slot>
    </ui-box-label>
    <slot />
  </v-sheet>
</template>

<script>
export default {
  props: {
    label: { type: String, required: false },
  },
}
</script>
